<template>
  <div v-html="time"></div>
</template>

<script>
export default {
  name: "ITable",
  props: {
    time: {
      type: String,
      default: "",
      required: true,
    },
  },
};
</script>
